import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

const adminPageService = {
  deletePage: async (user, pageTemplateId) => {
    return await axios.delete(
      `${NODE_BASE_URL}/admin/template/page/${pageTemplateId}`,
      getAxiosOptions(user)
    )
  },
  updatePageSequenceBulk: async (user, pages) => {
    return await axios.post(
      `${NODE_BASE_URL}/admin/template/page/update-sequence-bulk`,
      pages,
      getAxiosOptions(user)
    )
  },
}

export default adminPageService
